<div class="Item" *ngIf="itemList?.length>0">
    <h2>My Item List({{itemList.length}})</h2>
    <div class="spares-card">
      <div class="logo">
        <img src="{{vehicleData.imageUrlPath}}" alt="Logo" />
      </div>
      <div class="details">
        <p><strong>{{vehicleData.model}}, {{vehicleData.fuel}}</strong></p>
        <p>{{vehicleData.variant}}, [{{vehicleData.year}}]</p>
        <p>{{vehicleData.registrationNumber}}</p>
      </div>
    </div>
  
  <div class="container">
    <!-- Sidebar -->
    <div class="sidebar">
      <mat-nav-list style="padding: 0 0;border-bottom: 1px solid #8b8b8b;"  *ngFor="let item of itemList; let i = index" [class.selected]="selectedItem?.id === item.id">
        <mat-list-item
           
            (click)="selectItem(item)"
            [class.selected]="selectedItem?.id === item.id"
            >
            <!-- <span matLine>{{ transform(item.name) }}</span> -->
            <span matLine *ngIf="item.products?.length > 0; else noItem">{{ transform(item.name) }}</span>
            
            <span matLine style="font-size:11px; font-weight: 100;" *ngIf="item.products?.length > 0">{{ transform(item.name) }}</span>
            <span matLine style="font-size:11px; font-weight: 100;" *ngIf="item.products?.length <= 0">No Item Found</span>

            <ng-template #noItem><span matLine>{{ transform(item.name) }}</span></ng-template>            
            <!-- <span matLine style="font-size:11px; font-weight: 100;">{{ item.name }}</span> -->
            <!-- <span matLine style="font-size:11px; font-weight: 100;">{{ transform(item.name) }}</span> -->
            <!-- Show heart icon for 0 results -->
            <div *ngIf="item.products?.length === 0" class="fev">
              <mat-icon
                (click)="toggleWishlist(item)"
                [ngClass]="{ 'wishlist-selected': item.inWishlist }"
              >
                {{ item.inWishlist ? 'favorite' : 'favorite_border' }}
              </mat-icon>
            
              <!-- CTA if heart is selected -->
              <!-- <div *ngIf="item.inWishlist" class="wishlist-cta">
                <mat-icon>favorite</mat-icon>
                Add to Request Wishlist
              </div> -->
            </div>

            <!-- Normal results text -->
            <span
              style="font-size: 11px;"
              *ngIf="item.products?.length > 0 && item.products.length <= 10 && item.addedToCart != true"
            >
              {{ item.products.length }} results
            </span>

            <span style="font-size: 11px;" *ngIf="item.products?.length>10 && item.addedToCart!=true">10+ items</span>
            <span class="added-sec" *ngIf="item.addedToCart==true"><mat-icon class="added-icon">check_circle_outline</mat-icon> <span class="added-text">Added</span></span>
            <i class="material" (click)="openEdit(item)">edit</i>
            <div class="overlay" [class.visible]="editSheetOpen" (click)="closeEdit()"></div>

            <div class="edit-item-container" *ngIf="editSheetOpen && editingItem?.id === item.id">
                <div class="edit-item-content">
                    <h3 style="margin-top: -6px;">Edit Item</h3>
                    <button class="close-btn" (click)="closeEdit()">
                        <i class="material-icons" (click)="closeEdit()">close</i>
                    </button>
                <form [formGroup]="editItemForm" autocomplete="off">
                  <div class="form-group">
                    <label for="itemName"></label>
                    <div class="input-container">
                      <input #myInput
                        type="text"
                        id="itemName"
                        formControlName="itemName"
                        [(ngModel)]="searchText"
                        (input)="filterSuggestions()"
                      />
                      <i class="input-icon" style="right: 39px;" (click)="closeText()">close</i>
                      <mat-icon class="input-icon" (click)="saveChanges()">arrow_upward</mat-icon>
                    </div>
                    <div class="form-actions">
                      <div class="form-actions-left">
                        <i class="material-icons remove-icon" (click)="removeFromList(item)">close</i>
                        <button type="button" class="remove-btn" (click)="removeFromList(item)">Remove from list</button>
                      </div>
                      <!-- <div class="form-actions-right">
                        <button type="button" class="save-btn" (click)="saveChanges()" style="color: #144579; padding: 0 0;">Save Changes</button>
                      </div> -->
                    </div>   
                    
                    <div #dropdown class="suggestions" *ngIf="suggestions.length > 0 && searchTextShow">
                      <div *ngFor="let suggestion of suggestions; let i = index" (click)="selectSuggestion1(suggestion)">
                        <i class="material-icons" *ngIf="isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">access_time</i>
                        <i class="material-icons" *ngIf="!isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">search</i>
                        <span [innerHTML]="getHighlightedText(suggestion.value, searchText)" style="font-size: 12px;"></span>

                      </div>
                    </div>
                    <div class="enterbutton">
                      <button class="cta-btn" (click)="saveChanges()">Edit Item</button>
                    </div>                 
                  </div>
                </form>
                </div>
            </div>
                    
        </mat-list-item>
<div *ngIf="!item.products?.length && item.suggestions1?.length > 1" class="no-result-box">
           
          <div class="suggestion-box" >
            <div class="suggestion-title">Did you mean?</div>
            <div class="chip-group">
              <div
                *ngFor="let suggestion of item.suggestions1"
                class="chip"
                [class.selected]="selectedSuggestion === suggestion"
                (click)="selectSuggestion(suggestion, item)"
              >
                {{ suggestion }}
              </div>
              <div  class="chip" (click)="openEdit(item)">None of these</div>
            </div>
          </div>
        </div>
      </mat-nav-list>
    </div>
  
    <!-- Content -->
    <div class="content">  
      <h2>{{ transform(selectedItem?.name) || 'Select a Item'  }}</h2>
      <div class="product-grid" *ngIf="selectedItem?.products?.length > 0">
        <mat-card *ngFor="let product of selectedItem?.products" class="product-card">
          <!-- <a [routerLink]="['/product-details/key/']"> -->
            <div class="product-badge">
                <span class="discount1" *ngIf="getDiscount(product) ">{{getDiscount(product) }}% OFF</span>
                <!-- <span class="bought" *ngIf="product.soldQuantity>0">Previously Bought</span> -->
                <div>
                  <div *ngIf="product.partInfo.soldCount  > 0" class="sku-tag-top-right ordered-count tag ordered-count">
                      {{ product.partInfo.soldCount }} {{  product.partInfo.soldCount  === 1 ? 'Unit' : 'Units' }} Sold
                  </div>
              
                  <div *ngIf="product.partInfo.soldCount  > 0"  class="sku-tag-top-right previously-bought tag ordered-count">
                      Previously Bought
                  </div>
              </div>
              
            </div>
            <!-- <img mat-card-image src="{{product.productImageUrl}}" alt="{{ product.partName }}" /> -->
            <img mat-card-image [src]="product.partInfo.productImageUrl || '../../../../assets/images/logos/logo.png'" 
            alt="{{ product.partInfo.productImageUrl ? product.partInfo.partName : 'autoverse' }}" onerror="this.src='../../../../assets/images/logos/logo.png'" />
       
            <!-- <mat-card-content style="color: black;"> -->
              <h3>{{ product.partInfo.partName }}</h3>
              <div class="price">
                  <span class="current-price" *ngIf="getSellingPrice(product)">₹{{getSellingPrice(product) }}</span>
                  <span class="original-price" *ngIf="getDiscount(product)">₹{{ getRate(product) }}</span>
                  <div class="toolbar-separator" *ngIf="getDiscount(product)"></div>
                  <!-- <span class="current-price" *ngIf="!getDiscount(product)">₹{{ getRate(product) }}</span> -->
                  <span class="discount" *ngIf="getDiscount(product)">{{ getDiscount(product) }}% OFF</span>
              </div>
              <div class="product-rating">
                  <span class="star"><i class="material-icons star-icon">star</i></span> 5 Ratings
              </div>
              <div class="product-details">
                <div class="detail-item">
                  <img src="../../../../assets/images/spares-list-images/unnamed (1).png" style="width: 18px;height: 18px;" alt="PN">
                  {{product.partInfo.partNumber}}</div>
                <div class="detail-item">
                  <img src="../../../../assets/images/spares-list-images/unnamed.png" style="width: 18px;
                  height: 18px;" alt="B">
                  {{product.partInfo.brand}}</div>
                <div style="    height: 25px;">
                  <div class="detail-item">
                    <img src="../../../../assets/images/spares-list-images/unnamed (2).png"style="width: 18px;
                    height: 18px; " alt="T">
                    {{product.partInfo.deliveryTime}}
                  </div>
                  <div class="spare-add-cart" >
                    <button  *ngIf="cartList.length<=0" (click)="addCart(product, 1)" class="add-control">
                        <mat-icon style="top: 3px; position: relative;">control_point</mat-icon>
                        Add
                    </button> 
                    <button *ngIf="cartList.length>0 && !cartList[0][product.partInfo.partKey]"  (click)="addCart(product, 1)" class="add-control">
                        <mat-icon style="top: 3px; position: relative;">control_point</mat-icon>
                        Add
                    </button> 
                  <!-- {{product.partKey}}--------
                    {{cartList[0][product.partKey]|json}} -->
                </div>
                <div class="addtocartcompatiblecar1" *ngIf="cartList[0] && cartList[0][product.partInfo.partKey]" >
                  <!-- {{cartList[0][product.partKey]|json}} -->
                    <div class="spare-add-cart1">
                        <div class="btn-group" *ngIf="product.partInfo.partKey==cartList[0][product.partInfo.partKey].partKey && cartList[0][product.partInfo.partKey].cart_qty>0" >
                          <button class="button1" mat-raised-button (click)="removeItem(cartList[0][product.partInfo.partKey].cart_qty, product.partInfo.partKey)">
                                <mat-icon class="sidebuttons1">remove</mat-icon>
                          </button>
                            <input type="text" [(ngModel)]="cartList[0][product.partInfo.partKey].cart_qty" readonly>
                          <button  class="button1" mat-raised-button (click)="addItem(cartList[0][product.partInfo.partKey].cart_qty, product.partInfo.partKey)">
                                <mat-icon class="sidebutton1">add</mat-icon>
                          </button>
                        </div>
                    </div>
                </div>
                </div>

              </div>
              
              <!-- Add to cart -->
              
          <!-- End add to cart -->
        <!-- </mat-card-content> -->
          <!-- </a> -->
        
        </mat-card>
      </div>

      <div class="empty-item" *ngIf="selectedItem?.products?.length <= 0 && selectedItem?.inWishlist==false">
          <!-- <img style="padding: 0px 0px 25px;"src="{{emptyImg}}" alt="" /> -->
          <div class="sec1">No matches found</div>
          <div class="sec2">We couldn't find a matching item</div>
          <button mat-button class='browse-parts-btn' (click)="toggleWishlist(selectedItem)">
            <mat-icon
            [ngClass]="{ 'wishlist-selected': transform(selectedItem?.name).inWishlist }"
            >{{ transform(selectedItem?.name).inWishlist ? 'favorite' : 'favorite_border' }}</mat-icon>
            Add to Request Wishlist</button>

      </div>
      <div class="empty-item" *ngIf="selectedItem?.products?.length <= 0 && selectedItem?.inWishlist==true">
        <!-- <img style="padding: 0px 0px 25px;"src="{{emptyImg}}" alt="" /> -->
        <div class="sec1">No matches found</div>
        <div class="sec2">We couldn't find a matching item</div>
        <div class="wishlist-header">
          <div class="added">
            <mat-icon style="margin-top: 7px;">favorite</mat-icon>
        <div class="section1">Added to Request Wishlist</div>
          <div class="wishlist-quantity">
            <mat-icon (click)="decreaseQty(selectedItem)">remove</mat-icon>
            <span style="color: #144579;padding-left: 10px;margin-bottom: 3px;">{{ getItemQuantity(selectedItem?.name) || 1 }}</span>
            <mat-icon (click)="increaseQty(selectedItem)">add</mat-icon>
          </div>
        </div>
        </div>
    </div>
    </div>
  </div>
</div>

<div class="loading-container" *ngIf="loading">
  <div class="loading-background"></div>
  
  <ng-lottie
  class="animation"
  [options]="options"
  (animationCreated)="animationCreated($event)">
</ng-lottie>
<p class="message">{{ randomMessage }}</p>

</div>
 <div class="overlay" [class.visible]="addWishlist" (click)="closePopup()"></div>
<div *ngIf="addWishlist" class="popup">
  <div style="text-align: end;">
    <i (click)="closePopup()" style="cursor: pointer;"> cancel</i>
  </div>
  <div>
    <img src="../../../../assets/images/wishlist.png" style="width: 85%;">
  </div>
  <div style="text-align: center;margin-top: 12px;">
    <button class="okay" (click)="yesPopup()">Yes Please</button>
  </div>
  <div style="text-align: center;margin-top: 12px;">
    <button class="thank" (click)="closePopup()">No, Thank you I'll add them one by one</button>
  </div>
</div>